export default "__VITE_ASSET__hpFJm35QgUQDOqEpwO7D$w__"